import React, { useState } from 'react';
import MapaLeaflet from '../mapa/MapaLeaflet';
import { ESTILOS_MAPA, estiloMapa, guardarEstiloMapa } from '../mapa/estiloMapa';

// Elegir cómo se ve el mapa (12-oct-2026). Se aplica al instante en todos los mapas de la app,
// en este navegador. Muestra de ejemplo: Obelisco y Estación Lanús.
const MUESTRA = [
    { id: 'obelisco', lat: -34.6037, lng: -58.3816, color: '#C9341F', etiqueta: '1' },
    { id: 'lanus', lat: -34.7064, lng: -58.3917, color: '#111827', etiqueta: 'B' },
];

export default function EstiloMapa() {
    const [actual, setActual] = useState(estiloMapa);
    const elegir = (id) => { setActual(id); guardarEstiloMapa(id); };
    return (
        <section className="rounded-2xl bg-card border border-black/[0.07] dark:border-white/[0.07] p-4 space-y-3">
            <p className="text-label font-black text-muted uppercase tracking-widest">Cómo se ve el mapa</p>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-2">
                {ESTILOS_MAPA.map(e => (
                    <button key={e.id} type="button" onClick={() => elegir(e.id)}
                        className={`p-3 rounded-xl text-left active:scale-[0.98] transition-all ${actual === e.id ? 'bg-brand-red text-white' : 'bg-chip text-ink'}`}>
                        <span className="block text-body font-black">{e.nombre}</span>
                        <span className={`block text-caption ${actual === e.id ? 'text-white/85' : 'text-muted'}`}>{e.detalle}</span>
                    </button>
                ))}
            </div>
            <div className="rounded-xl overflow-hidden border border-black/[0.07] dark:border-white/[0.07]">
                <MapaLeaflet puntos={MUESTRA} ajustarKey="muestra" className="h-64" />
            </div>
            <p className="text-caption text-muted">
                Se guarda en este navegador y cambia todos los mapas de la app. Los mapas quedan dentro de AMBA.
                En modo oscuro el mapa se oscurece solo.
            </p>
        </section>
    );
}
